import React, { Component } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import isEqual from 'lodash/isEqual';

import { uiLocations } from 'constants/analytics';

// Components
import LoadingWrapperContainer from 'api/loading/LoadingWrapperContainer';
import ScriptCreatorHeader from 'edit/ScriptCreatorHeader';
import ScriptCreatorBody from 'edit/ScriptCreatorBody';
import SelectAffiliateOrganizationModalContainer from 'common/modals/SelectAffiliateOrganizationModalContainer';
import OverlaySelectModalContainer from 'common/modals/OverlaySelectModalContainer';
import SeedProductSelectorContainer from 'edit/seed-product-selector/SeedProductSelectorContainer';
import ConnectToAffiliateModalContainer from 'common/modals/ConnectToAffiliateModalContainer';
import PreferredDeviceModal from 'common/modals/PreferredDeviceModal';

const baseString = 'vra-script-creator';
class EditContainer extends Component {

  componentDidMount() {
    this.props.onMount({
      canManualScript: this.props.canManualScript,
      isAppMode: this.props.isAppMode
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  render() {
    const {
      canChooseSeedProduct,
      exportOptionsIsOpen,
      isAppMode,
      isExitButtonVisible,
      isOverlaySelectModalActive,
      isSaveTriggerEnabled,
      onClickExportTrigger,
      onClickCancelTrigger,
      onClickSaveTrigger,
      scriptConfigView,
      scriptId,
      script,
      scriptLoadIsInProgress,
      selectedZoneIds,
      shouldScrollToSelectedZone,
      showLiquidApplication,
      redirectUrl,
    } = this.props;

    const classString = classNames({
      [`${baseString}`]: true,
      [`${baseString}--script-config-${scriptConfigView}`]: true,
      'vra-route-container': true,
      'vra-route-container--edit': true,
      'vra-route-container--app-mode': isAppMode
    });

    let style = {};
    if (isAppMode) {
      style = {
        height: `${window.innerHeight}px`
      };
    }

    return (
      <LoadingWrapperContainer initialLoadIsInProgress={scriptLoadIsInProgress}>
        <section className={classString} style={style}>
          <ScriptCreatorHeader
            exportOptionsIsOpen={exportOptionsIsOpen}
            isAppMode={isAppMode}
            isExitButtonVisible={isExitButtonVisible}
            isExportTriggerEnabled={false}
            isSaveTriggerEnabled={isSaveTriggerEnabled}
            onClickCancelTrigger={() => onClickCancelTrigger(script, redirectUrl)}
            onClickExportTrigger={onClickExportTrigger}
            onClickSaveTrigger={() => onClickSaveTrigger(scriptId)}
            scriptId={scriptId}
          />
          <ScriptCreatorBody
            canChooseSeedProduct={canChooseSeedProduct}
            scriptConfigView={scriptConfigView}
            selectedZoneIds={selectedZoneIds}
            shouldScrollToSelectedZone={shouldScrollToSelectedZone}
            showLiquidApplication={showLiquidApplication}
          />
          <SelectAffiliateOrganizationModalContainer />
          { isOverlaySelectModalActive && <OverlaySelectModalContainer /> }
          <SeedProductSelectorContainer />
          <PreferredDeviceModal />
          <ConnectToAffiliateModalContainer uiLocation={uiLocations.EDIT} />
        </section>
      </LoadingWrapperContainer>
    );
  }
}

EditContainer.propTypes = {
  applicationType: propTypes.string.isRequired,
  canChooseSeedProduct: propTypes.bool.isRequired,
  canManualScript: propTypes.bool.isRequired,
  exportOptionsIsOpen: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  isExitButtonVisible: propTypes.bool.isRequired,
  isExportTriggerEnabled: propTypes.bool,
  isOverlaySelectModalActive: propTypes.bool.isRequired,
  isSaveTriggerEnabled: propTypes.bool.isRequired,
  onClickCancelTrigger: propTypes.func.isRequired,
  onClickExitTrigger: propTypes.func.isRequired,
  onClickExportTrigger: propTypes.func.isRequired,
  onClickSaveTrigger: propTypes.func.isRequired,
  onMount: propTypes.func.isRequired,
  script: propTypes.object.isRequired,
  scriptConfigView: propTypes.string.isRequired,
  scriptId: propTypes.string.isRequired,
  scriptLoadIsInProgress: propTypes.bool.isRequired,
  selectedZoneIds: propTypes.array.isRequired,
  shouldScrollToSelectedZone: propTypes.bool.isRequired,
  showLiquidApplication: propTypes.bool.isRequired,
  redirectUrl: propTypes.string
};

export default EditContainer;
